// extracted by mini-css-extract-plugin
export default {"FooterTable":"Footer_FooterTable__k3Blr","FooterCell":"Footer_FooterCell__H4B5n"};